import React from "react";
import { node } from "prop-types";
import { Container, Row } from "../Grid";

const FooterContainer = ({ children, ...props }) => {
	return (
		<Container {...props}>
			<Row mx px>
				{children}
			</Row>
		</Container>
	);
};

FooterContainer.propTypes = {
	...Container.propTypes,
	children: node.isRequired,
};

export default FooterContainer;
